export type CategoryKey = 'latest' | 'hot' | 'classic';

export interface Movie {
  id: string;
  title: string;
  latin: string;
  cover: string;
  banner?: string;
  year: number;
  region: string;
  duration: number;
  rating: number;
  views: number;
  updatedAt: string;
  categories: CategoryKey[];
  director: string;
  actors: string[];
  tags: string[];
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: 'night-neon',
    title: '夜色霓虹',
    latin: 'Neon Nocturne',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20film%20still%20of%20an%20elegant%20woman%20in%20a%20long%20black%20trench%20coat%20standing%20in%20a%20rain-soaked%20neon%20alley%20in%20Shinjuku%20at%20night%2C%20warm%20amber%20and%20crimson%20practical%20lights%2C%20wet%20asphalt%20reflections%2C%20atmospheric%20haze%2C%20shallow%20depth%20of%20field%2C%20editorial%20cinematography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-neon-night&orientation=landscape',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rain-soaked%20Tokyo%20neon%20alley%20at%20night%2C%20elegant%20woman%20in%20black%20trench%20coat%20seen%20from%20behind%20walking%20away%2C%20warm%20amber%20and%20crimson%20signage%20glow%2C%20reflective%20wet%20pavement%2C%20atmospheric%20haze%2C%20moody%20premium%20cinematography%2C%20fully%20clothed%2C%20no%20text&width=1600&height=900&seq=av-banner-neon-night&orientation=landscape',
    year: 2026,
    region: '日本',
    duration: 128,
    rating: 9.2,
    views: 128400,
    updatedAt: '2026-10-18',
    categories: ['latest', 'hot'],
    director: '黑泽遥',
    actors: ['水野纱希', '高桥凉', '石川澪'],
    tags: ['都市', '夜色', '剧情'],
    synopsis:
      '一场持续整夜的暴雨，把两个原本毫无交集的陌生人困在新宿一条亮着霓虹的小巷里。摄影师与夜班调酒师从争执聊到彼此的年少往事，直到天光泛白，他们才发现这一夜改写了各自接下来的生活。',
  },
  {
    id: 'rain-tokyo',
    title: '雨夜东京',
    latin: 'Tokyo in the Rain',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20two%20silhouettes%20sharing%20an%20umbrella%20on%20a%20quiet%20Tokyo%20street%20during%20heavy%20rain%20at%20night%2C%20glowing%20vending%20machine%20and%20paper%20lantern%20light%2C%20muted%20shadows%20with%20warm%20highlights%2C%20film%20grain%2C%20atmospheric%20bokeh%2C%20fully%20clothed%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=av-cover-rain-tokyo&orientation=landscape',
    year: 2026,
    region: '日本',
    duration: 122,
    rating: 9.0,
    views: 96400,
    updatedAt: '2026-10-16',
    categories: ['latest', 'hot'],
    director: '小林澄',
    actors: ['夏川澪', '佐藤悠', '森田千夏'],
    tags: ['浪漫', '雨夜', '治愈'],
    synopsis:
      '伞下只有一把，路却还有很远。刚刚辞去工作的女孩与每天在同一时间经过的上班族，因为一场突如其来的暴雨共享了半小时的路程。此后每个雨天，他们都在同一个路口等待。',
  },
  {
    id: 'afternoon-cafe',
    title: '午后咖啡馆',
    latin: 'Afternoon, Black Coffee',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20of%20a%20sunlit%20vintage%20cafe%20interior%20with%20a%20woman%20in%20a%20cream%20knit%20sweater%20reading%20by%20the%20window%2C%20dust%20motes%20in%20golden%20afternoon%20light%2C%20wooden%20tables%2C%20soft%20film%20grain%2C%20calm%20intimate%20mood%2C%20editorial%20lifestyle%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-afternoon-cafe&orientation=landscape',
    year: 2025,
    region: '日本',
    duration: 108,
    rating: 8.7,
    views: 74200,
    updatedAt: '2026-10-15',
    categories: ['latest'],
    director: '小野真纪',
    actors: ['白石葵', '松本遥人'],
    tags: ['生活', '治愈', '慢节奏'],
    synopsis:
      '街角那家只开下午的咖啡馆即将关门。店主在最后一个营业季里，迎来了每天坐在同一位子的常客，也迎来了自己搁置多年的第二次选择。',
  },
  {
    id: 'coast-highway',
    title: '海岸公路',
    latin: 'Coastline 17',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20vintage%20car%20on%20a%20coastal%20highway%20at%20golden%20hour%2C%20woman%20in%20a%20linen%20shirt%20leaning%20out%20of%20the%20window%2C%20ocean%20cliffs%20and%20warm%20sunset%20haze%2C%20wind%20in%20her%20hair%2C%20anamorphic%20lens%20flare%2C%20film%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-coast-highway&orientation=landscape',
    year: 2026,
    region: '中国台湾',
    duration: 116,
    rating: 8.9,
    views: 88100,
    updatedAt: '2026-10-14',
    categories: ['latest', 'hot'],
    director: '陈映蓉',
    actors: ['林知微', '许亦航', '黄筱晴'],
    tags: ['公路', '夏天', '治愈'],
    synopsis:
      '一辆开了十五年的老车，一条沿着海岸线的省道，两个决定把周末延长成一周的人。他们不谈未来，只把沿途的便利店、旧唱片和落日一一记住。',
  },
  {
    id: 'champagne',
    title: '礼服与香槟',
    latin: 'Silk & Champagne',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20still%20of%20a%20rooftop%20cocktail%20party%20at%20dusk%2C%20woman%20in%20a%20deep%20red%20evening%20gown%20holding%20a%20champagne%20glass%2C%20city%20skyline%20bokeh%20behind%20her%2C%20warm%20amber%20and%20wine%20tones%2C%20luxurious%20editorial%20fashion%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-champagne&orientation=landscape',
    year: 2025,
    region: '韩国',
    duration: 134,
    rating: 8.6,
    views: 65300,
    updatedAt: '2026-10-12',
    categories: ['latest'],
    director: '尹智浩',
    actors: ['韩瑞妍', '郑在民', '李书英'],
    tags: ['悬疑', '上流社会', '剧情'],
    synopsis:
      '一场为慈善而办的屋顶酒会，宾客名单上却藏着一个不该出现的名字。当香槟塔被推倒，所有人都必须在体面与真相之间选一个。',
  },
  {
    id: 'midnight-study',
    title: '深夜书房',
    latin: 'The Study at Midnight',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20still%20of%20a%20dimly%20lit%20private%20library%20at%20midnight%2C%20woman%20in%20a%20white%20shirt%20writing%20at%20a%20wooden%20desk%20with%20a%20brass%20lamp%2C%20stacks%20of%20old%20books%2C%20deep%20shadows%2C%20warm%20pools%20of%20light%2C%20quiet%20intellectual%20atmosphere%2C%20film%20grain%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-midnight-study&orientation=landscape',
    year: 2024,
    region: '日本',
    duration: 98,
    rating: 8.4,
    views: 51200,
    updatedAt: '2026-10-11',
    categories: ['latest'],
    director: '内藤史',
    actors: ['绫濑千寻', '松冈圭'],
    tags: ['文艺', '文学', '慢节奏'],
    synopsis:
      '一位写不出第二本书的作家，在一间借来的旧书房里遇到了整理遗物的编辑。泛黄的手稿里写着一段无人知晓的往事，也写着他们各自的答案。',
  },
  {
    id: 'red-heels',
    title: '红色高跟鞋',
    latin: 'Red Heels',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20still%20of%20a%20woman%20in%20a%20tailored%20charcoal%20suit%20stepping%20out%20of%20a%20taxi%20at%20night%2C%20red%20high%20heels%20on%20wet%20pavement%2C%20city%20lights%20reflecting%2C%20dramatic%20side%20lighting%2C%20noir%20mood%2C%20editorial%20fashion%20cinematography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-red-heels&orientation=landscape',
    year: 2025,
    region: '韩国',
    duration: 112,
    rating: 8.8,
    views: 79500,
    updatedAt: '2026-10-09',
    categories: ['latest', 'hot'],
    director: '朴成勋',
    actors: ['姜多恩', '吴贤宇'],
    tags: ['都市', '情感', '职场'],
    synopsis:
      '她在首尔最忙的写字楼里工作了七年，却在一双旧鞋里发现了前任留下的地址。一个加班的深夜，她决定沿着那条街走一次。',
  },
  {
    id: 'rooftop-moon',
    title: '天台月光',
    latin: 'Moon over the Roof',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20young%20woman%20in%20a%20light%20summer%20dress%20sitting%20on%20a%20rooftop%20at%20night%20under%20a%20full%20moon%2C%20string%20lights%20and%20distant%20city%20glow%2C%20cool%20night%20air%20and%20warm%20lamps%2C%20soft%20film%20grain%2C%20dreamy%20youthful%20atmosphere%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-rooftop-moon&orientation=landscape',
    year: 2026,
    region: '日本',
    duration: 104,
    rating: 8.5,
    views: 43900,
    updatedAt: '2026-10-08',
    categories: ['latest'],
    director: '河合优',
    actors: ['川口葵', '井上航'],
    tags: ['青春', '夏夜', '成长'],
    synopsis:
      '毕业前的最后一个夏天，四个朋友把天台改造成秘密基地。他们约定十年后在这里见面，却没人敢说出口，有人已经准备离开这座城市。',
  },
  {
    id: 'private-pool',
    title: '私人泳池',
    latin: 'The Private Pool',
    cover:
      'https://readdy.ai/api/search-image?query=Luxury%20cinematic%20still%20of%20a%20private%20villa%20pool%20at%20twilight%20with%20a%20woman%20in%20a%20white%20linen%20cover-up%20seated%20on%20the%20edge%2C%20turquoise%20water%20reflections%20and%20warm%20lantern%20light%2C%20Mediterranean%20stone%20architecture%2C%20editorial%20travel%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-private-pool&orientation=landscape',
    year: 2025,
    region: '欧美',
    duration: 121,
    rating: 8.3,
    views: 38600,
    updatedAt: '2026-10-06',
    categories: ['latest'],
    director: 'L. Moreau',
    actors: ['Elena Rossi', 'Marc Vidal'],
    tags: ['度假', '悬疑', '欧陆'],
    synopsis:
      '一间位于地中海悬崖上的度假别墅，每周只接待一位客人。这一次到来的房客，带着一张二十年前在这里拍下的照片。',
  },
  {
    id: 'vinyl-store',
    title: '旧唱片店',
    latin: 'Vinyl & Rain',
    cover:
      'https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20still%20inside%20a%20narrow%20vintage%20record%20store%2C%20woman%20in%20a%20denim%20jacket%20flipping%20through%20vinyl%20sleeves%2C%20warm%20tungsten%20light%2C%20dust%20in%20the%20air%2C%20crates%20of%20records%20and%20posters%2C%20analog%20film%20look%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-vinyl-store&orientation=landscape',
    year: 2024,
    region: '日本',
    duration: 96,
    rating: 8.9,
    views: 60800,
    updatedAt: '2026-10-05',
    categories: ['latest', 'hot'],
    director: '大庭匠',
    actors: ['中村由纪', '小柳莲'],
    tags: ['音乐', '文艺', '怀旧'],
    synopsis:
      '唱片店老板有个奇怪的习惯：只卖听完能让人想起某个人的唱片。直到某天，一个女孩拿着B面被划伤的旧唱片走进来，说要找一首没人记得的歌。',
  },
  {
    id: 'midnight-train',
    title: '午夜列车',
    latin: 'The Midnight Line',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20an%20empty%20night%20train%20carriage%2C%20woman%20in%20a%20beige%20trench%20coat%20looking%20out%20of%20the%20window%20at%20passing%20city%20lights%2C%20long%20exposure%20light%20streaks%2C%20deep%20amber%20reflections%2C%20mysterious%20mood%2C%20anamorphic%20cinematography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-midnight-train&orientation=landscape',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20night%20train%20window%20with%20blurred%20city%20light%20streaks%2C%20woman%20in%20beige%20trench%20coat%20reflected%20in%20the%20glass%2C%20deep%20amber%20and%20charcoal%20tones%2C%20mysterious%20premium%20film%20look%2C%20fully%20clothed%2C%20no%20text&width=1600&height=900&seq=av-banner-midnight-train&orientation=landscape',
    year: 2026,
    region: '韩国',
    duration: 118,
    rating: 9.1,
    views: 102300,
    updatedAt: '2026-10-03',
    categories: ['latest', 'hot'],
    director: '郑河那',
    actors: ['徐允儿', '朴泰俊', '金度妍'],
    tags: ['悬疑', '列车', '夜行'],
    synopsis:
      '末班车上只有七位乘客，却没有人记得自己是怎么上车的。当列车第三次经过同一个站台，一位女记者决定在到站前找出那个不属于这趟车的人。',
  },
  {
    id: 'mirror-light',
    title: '镜中光影',
    latin: 'Mirror, Light',
    cover:
      'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20still%20of%20an%20elegant%20woman%20in%20a%20long%20black%20dress%20seen%20through%20a%20frosted%20glass%20door%2C%20geometric%20shadows%20and%20warm%20rim%20light%2C%20minimal%20modern%20interior%2C%20abstract%20composition%2C%20editorial%20art%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-mirror-light&orientation=landscape',
    year: 2025,
    region: '欧美',
    duration: 110,
    rating: 8.2,
    views: 29800,
    updatedAt: '2026-10-02',
    categories: ['latest'],
    director: 'A. Bergman',
    actors: ['Clara Weiss', 'Jonas Falk'],
    tags: ['艺术', '实验', '剧情'],
    synopsis:
      '一位舞台灯光设计师接下了职业生涯中最难的委托：为一座空剧场设计一场没有演员的演出。排练过程中，她开始分不清光与记忆哪一个更真实。',
  },
  {
    id: 'hotel-301',
    title: '酒店301',
    latin: 'Room 301',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20noir%20still%20of%20a%20hotel%20corridor%20at%20night%2C%20brass%20room%20number%20301%20glowing%2C%20woman%20in%20a%20silk%20robe%20standing%20by%20the%20door%20with%20a%20suitcase%2C%20warm%20sconce%20light%20and%20long%20shadows%2C%20mysterious%20atmosphere%2C%20film%20grain%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-hotel-301&orientation=landscape',
    year: 2024,
    region: '日本',
    duration: 105,
    rating: 8.7,
    views: 57200,
    updatedAt: '2026-09-29',
    categories: ['latest'],
    director: '真锅隆',
    actors: ['若林沙也', '津田健'],
    tags: ['悬疑', '密室', '剧情'],
    synopsis:
      '一位长期住在老酒店里的女作家，每晚都能听见隔壁301房间有人在打字。可这层楼已经封闭了十二年，钥匙一直挂在柜台后面。',
  },
  {
    id: 'white-shirt',
    title: '白色衬衫',
    latin: 'The White Shirt',
    cover:
      'https://readdy.ai/api/search-image?query=Clean%20cinematic%20still%20of%20a%20woman%20in%20an%20oversized%20white%20shirt%20in%20a%20modern%20office%20at%20dusk%2C%20floor%20to%20ceiling%20windows%20with%20city%20skyline%2C%20cool%20daylight%20mixed%20with%20warm%20desk%20lamp%2C%20composed%20editorial%20portrait%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-white-shirt&orientation=landscape',
    year: 2025,
    region: '韩国',
    duration: 100,
    rating: 8.6,
    views: 48100,
    updatedAt: '2026-09-27',
    categories: ['latest'],
    director: '申惠珍',
    actors: ['李彩媛', '金泰吾'],
    tags: ['职场', '都市', '情感'],
    synopsis:
      '她在公司加班到凌晨，却发现自己的白衬衫上多了一枚不属于自己的纽扣。顺着这枚纽扣，她翻出了整个部门都在回避的那份报告。',
  },
  {
    id: 'late-summer',
    title: '夏末晚风',
    latin: 'Late Summer Breeze',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20two%20friends%20on%20bicycles%20along%20a%20rural%20Japanese%20road%20at%20golden%20hour%20in%20late%20summer%2C%20sunflower%20fields%20and%20power%20lines%2C%20warm%20hazy%20sunlight%2C%20nostalgic%20youth%20atmosphere%2C%20Kodak%20film%20tones%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-late-summer&orientation=landscape',
    year: 2026,
    region: '日本',
    duration: 102,
    rating: 8.9,
    views: 66300,
    updatedAt: '2026-09-25',
    categories: ['latest', 'hot'],
    director: '冈田真昼',
    actors: ['加藤玲', '山崎树', '吉冈花'],
    tags: ['青春', '田园', '治愈'],
    synopsis:
      '小镇的公交线路即将取消，三个高中生决定在暑假结束前，骑车去一次县界上的那座旧车站。沿途的风把他们藏了一整个夏天的话都吹了出来。',
  },
  {
    id: 'seaside-villa',
    title: '海边别墅',
    latin: 'The Seaside House',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20white%20seaside%20villa%20terrace%20at%20midday%2C%20woman%20in%20a%20straw%20hat%20and%20long%20sundress%20overlooking%20a%20turquoise%20bay%2C%20linen%20curtains%20blowing%2C%20bright%20natural%20light%2C%20editorial%20travel%20cinematography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-seaside-villa&orientation=landscape',
    year: 2024,
    region: '中国台湾',
    duration: 124,
    rating: 8.4,
    views: 35400,
    updatedAt: '2026-09-22',
    categories: ['latest'],
    director: '吴昀',
    actors: ['苏映雪', '张祐宁'],
    tags: ['度假', '家庭', '剧情'],
    synopsis:
      '三兄妹为了处理母亲留下的海边老屋，在夏天回到多年未归的小镇。清理房间的七天里，他们重新拼起了那个谁都不愿提起的暑假。',
  },
  {
    id: 'behind-lens',
    title: '镜头之后',
    latin: 'Behind the Lens',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20still%20of%20a%20film%20set%20at%20night%2C%20woman%20director%20in%20a%20black%20jacket%20holding%20a%20monitor%2C%20warm%20tungsten%20lights%20and%20camera%20rigs%2C%20crew%20silhouettes%2C%20documentary%20style%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-behind-lens&orientation=landscape',
    year: 2025,
    region: '日本',
    duration: 130,
    rating: 8.8,
    views: 71400,
    updatedAt: '2026-09-20',
    categories: ['latest'],
    director: '浅野亮',
    actors: ['宫下遥', '今井拓', '长谷川澪'],
    tags: ['行业', '电影', '剧情'],
    synopsis:
      '一位被贴上「只会拍广告」标签的女导演，终于拿到长片的执导机会。三十六天的拍摄期里，她要对抗预算、天气，以及自己那套从不失手的完美主义。',
  },
  {
    id: 'first-snow',
    title: '第一场雪',
    latin: 'First Snow',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20quiet%20Seoul%20street%20during%20the%20first%20snowfall%2C%20woman%20in%20a%20wool%20coat%20with%20a%20red%20scarf%20looking%20up%20at%20falling%20snow%2C%20warm%20shop%20window%20glow%2C%20soft%20winter%20light%2C%20romantic%20film%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-first-snow&orientation=landscape',
    year: 2026,
    region: '韩国',
    duration: 112,
    rating: 9.0,
    views: 82900,
    updatedAt: '2026-09-18',
    categories: ['latest', 'hot'],
    director: '柳承雅',
    actors: ['全素妍', '安宰旭'],
    tags: ['爱情', '冬季', '重逢'],
    synopsis:
      '十年前他们约好，下第一场雪的那天在钟路的路口见面。今年首尔的初雪来得特别晚，而她已经在同一个位置等了三个冬天。',
  },
  {
    id: 'ginza-lights',
    title: '银座最后一盏灯',
    latin: 'The Last Light of Ginza',
    cover:
      'https://readdy.ai/api/search-image?query=Vintage%20cinematic%20still%20of%20a%20Ginza%20street%20corner%20in%20the%201980s%2C%20woman%20in%20a%20burgundy%20coat%20under%20a%20glowing%20sign%2C%20warm%20analog%20film%20grain%2C%20retro%20color%20grading%2C%20nostalgic%20night%20atmosphere%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-ginza-lights&orientation=landscape',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20vintage%20cinematic%20still%20of%20a%201980s%20Ginza%20street%20at%20night%20with%20glowing%20signage%20and%20woman%20in%20burgundy%20coat%20crossing%2C%20warm%20analog%20film%20grain%2C%20retro%20premium%20color%20grading%2C%20fully%20clothed%2C%20no%20text&width=1600&height=900&seq=av-banner-ginza-lights&orientation=landscape',
    year: 2016,
    region: '日本',
    duration: 118,
    rating: 9.3,
    views: 214600,
    updatedAt: '2024-06-12',
    categories: ['classic', 'hot'],
    director: '绪方隆',
    actors: ['原田幸子', '大川彻'],
    tags: ['经典', '昭和', '都市'],
    synopsis:
      '泡沫年代的最后一年，银座一家老酒吧的老板娘决定在除夕夜关店。最后一晚，五位老客人陆续到来，各自带着一个必须说出口的消息。',
  },
  {
    id: 'kyoto-after-rain',
    title: '京都雨停之后',
    latin: 'Kyoto, After the Rain',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20Kyoto%20wooden%20lane%20just%20after%20rain%2C%20woman%20in%20a%20pale%20kimono%20walking%20past%20wet%20stone%20lanterns%2C%20soft%20overcast%20light%20and%20reflections%2C%20moss%20garden%20in%20background%2C%20poetic%20quiet%20mood%2C%20medium%20format%20film%20look%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-kyoto-rain&orientation=landscape',
    year: 2017,
    region: '日本',
    duration: 126,
    rating: 9.4,
    views: 198200,
    updatedAt: '2024-05-30',
    categories: ['classic'],
    director: '森下圭介',
    actors: ['藤间千鹤', '西园寺凉'],
    tags: ['经典', '文艺', '京都'],
    synopsis:
      '一场雨后，京都一条安静的小巷里，两位多年未见的旧友在一家茶屋前重逢。一个下午的对话，把二十年前那场没有告别的分别重新讲了一遍。',
  },
  {
    id: 'harbor-summer',
    title: '港口的夏天',
    latin: 'Harbor Summer',
    cover:
      'https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20still%20of%20a%20small%20Taiwanese%20harbor%20in%20summer%2C%20teenagers%20sitting%20on%20a%20concrete%20pier%20with%20fishing%20boats%20behind%2C%20bright%20sunlight%20and%20faded%20pastel%20colors%2C%201990s%20film%20grain%2C%20coming%20of%20age%20atmosphere%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-harbor-summer&orientation=landscape',
    year: 2015,
    region: '中国台湾',
    duration: 108,
    rating: 9.0,
    views: 156400,
    updatedAt: '2024-04-18',
    categories: ['classic'],
    director: '侯孝贤',
    actors: ['林柏宏', '简嫚书'],
    tags: ['经典', '青春', '海边'],
    synopsis:
      '渔港少年在高中最后一个暑假里，第一次跟着父亲的船出海。他以为自己在等待离港，后来才明白是在等一句告别。',
  },
  {
    id: 'old-cinema',
    title: '老电影院的下午',
    latin: 'An Afternoon at the Cinema',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20of%20an%20old%20Parisian%20cinema%20lobby%20in%20the%20afternoon%2C%20woman%20in%20a%20trench%20coat%20buying%20a%20ticket%20at%20the%20wooden%20booth%2C%20art%20deco%20details%20and%20velvet%20curtains%2C%20amber%20lamplight%2C%20analog%20film%20grain%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-old-cinema&orientation=landscape',
    year: 2018,
    region: '法国',
    duration: 132,
    rating: 9.2,
    views: 143900,
    updatedAt: '2024-03-22',
    categories: ['classic'],
    director: 'C. Laurent',
    actors: ['Juliette Marchand', 'Paul Rivière'],
    tags: ['经典', '巴黎', '文艺'],
    synopsis:
      '巴黎一家只放映老片的小影院即将停业。最后一周，售票员与一位每周三都来的观众，用七部电影完成了他们从未开始的对话。',
  },
  {
    id: 'sapporo-snow',
    title: '札幌的雪',
    latin: 'Snow in Sapporo',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20winter%20still%20of%20a%20Sapporo%20side%20street%20at%20night%2C%20woman%20in%20a%20long%20camel%20coat%20walking%20through%20heavy%20snow%20under%20a%20streetlamp%2C%20warm%20windows%20and%20blue%20snow%20shadows%2C%20quiet%20melancholy%2C%20film%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-sapporo-snow&orientation=landscape',
    year: 2014,
    region: '日本',
    duration: 114,
    rating: 8.9,
    views: 121700,
    updatedAt: '2024-02-09',
    categories: ['classic'],
    director: '岩井俊',
    actors: ['中山美咲', '丰川悦'],
    tags: ['经典', '冬季', '爱情'],
    synopsis:
      '一封寄错地址的信，让东京的年轻女子在隆冬来到札幌。她循着信里的街道找下去，遇见的却是自己从未了解的过去。',
  },
  {
    id: 'slow-tide',
    title: '慢潮',
    latin: 'Slow Tide',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20rocky%20Korean%20coastline%20at%20dusk%2C%20woman%20in%20a%20grey%20knit%20sweater%20standing%20at%20the%20water%20edge%20with%20waves%20in%20long%20exposure%2C%20overcast%20sky%20and%20soft%20muted%20tones%2C%20contemplative%20mood%2C%20editorial%20film%20photography%2C%20fully%20clothed%2C%20no%20text&width=800&height=450&seq=av-cover-slow-tide&orientation=landscape',
    year: 2019,
    region: '韩国',
    duration: 120,
    rating: 9.1,
    views: 167800,
    updatedAt: '2024-01-15',
    categories: ['classic', 'hot'],
    director: '金星洙',
    actors: ['文素丽', '李善均'],
    tags: ['经典', '海边', '剧情'],
    synopsis:
      '一位海洋声学研究员回到故乡的小岛，记录即将被填平的海湾。她的录音带里，慢慢出现了母亲年轻时的声音。',
  },
];

export interface Collection {
  id: string;
  title: string;
  subtitle: string;
  meta: string;
  image: string;
  to: string;
}

export const collections: Collection[] = [
  {
    id: 'city-nights',
    title: '夜色都市系列',
    subtitle: '霓虹、雨与午夜街角',
    meta: '24 部影片',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20night%20city%20photograph%20of%20a%20rain-soaked%20alley%20with%20glowing%20amber%20neon%20signs%2C%20wet%20asphalt%20reflections%2C%20empty%20street%2C%20moody%20film%20noir%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=av-collection-city-nights&orientation=landscape',
    to: '/category/latest',
  },
  {
    id: 'restored',
    title: '经典修复特辑',
    subtitle: '被时间擦亮的老胶片',
    meta: '18 部影片',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20of%20an%20empty%20vintage%20cinema%20auditorium%20with%20red%20velvet%20seats%20and%20a%20glowing%20blank%20screen%2C%20projector%20beam%20and%20dust%2C%20analog%20film%20grain%2C%20nostalgic%20atmosphere%2C%20no%20text&width=800&height=600&seq=av-collection-restored&orientation=landscape',
    to: '/category/classic',
  },
  {
    id: 'top-rated',
    title: '高分人气榜',
    subtitle: '本周播放量前十',
    meta: '10 部影片',
    image:
      'https://readdy.ai/api/search-image?query=Dark%20elegant%20cinematic%20photograph%20of%20a%20film%20clapperboard%20and%20folded%20script%20on%20a%20wooden%20table%2C%20warm%20amber%20lamp%20light%2C%20deep%20shadows%2C%20premium%20editorial%20still%20life%2C%20no%20text&width=800&height=600&seq=av-collection-top-rated&orientation=landscape',
    to: '/category/hot',
  },
  {
    id: 'mood-jp',
    title: '日系情绪影像',
    subtitle: '慢节奏与生活感',
    meta: '16 部影片',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20quiet%20Japanese%20tatami%20room%20with%20open%20shoji%20doors%2C%20summer%20breeze%20moving%20linen%20curtains%2C%20green%20garden%20outside%2C%20warm%20soft%20natural%20light%2C%20calm%20minimal%20composition%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=av-collection-mood-jp&orientation=landscape',
    to: '/category/latest',
  },
];